import React, { createContext, useContext, useEffect, useState } from "react";
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from "../services/sessionStorageServices"; // Adjust the path as necessary
import { post } from "../apiService";

import { message, notification } from "antd";

const CartContext = createContext();

export const useCartContext = () => useContext(CartContext);

const CartProvider = ({ children }) => {
  const [cartValue, setCartValue] = useState(
    getSessionStorageItem("cart") || []
  );
  const [cartCount, setCartCount] = useState(0);
  const [showCartList, setShowCartList] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [branchData, setBranchData] = useState([]);
  const [branchId, setBranchId] = useState([]);
  const [branchDetail, setBranchDetail] = useState(null);
  const [tipPrice, setTipPrice] = useState(20);
  const [totalPrice, setTotalPrice] = useState([]);
  const handleCartList = () => setShowCartList((prev) => !prev);

  // selected priduct details

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedHight, setSelectedHight] = useState(null);
  const [selectedwidth, setSelectedwidth] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [selectedImages, setSelectedImages] = useState(null);
  const [selectedWeight, setSelectedWeight] = useState(null);
  /////====gestdetail====///

  // price state

  const [amountDetails, setAmountDetials] = useState({
    totalAmount: "",
    subTotal: "",
    texAmount: "",
  });

  const [guestDetails, setGuestDetails] = useState(null);

  const updateGuestDetails = (details) => {
    setGuestDetails(details);
  };

  // Function to calculate total item price
  const totalItemPrice = () => {
    return cartValue.reduce(
      (total, product) => total + parseFloat(product.price * product.itemQty),
      0
    );
  };

  // Function to calculate sales tax
  const salesTextPrice = (itemTotal) => {
    return (itemTotal * 10) / 100;
  };

  // ===================== Added Into Cart ===============
  const handleAddCart = (value) => {
    if (cartValue.length > 0) {
      const index = cartValue.findIndex(
        (valueCheck) =>
          valueCheck.product_id === value.product_id &&
          valueCheck.sive_sizes === value.sive_sizes &&
          valueCheck.diam_mm === value.diam_mm &&
          valueCheck.avg_wt === value.avg_wt &&
          valueCheck.color === value.color &&
          valueCheck.shade === value.shade &&
          valueCheck.cut === value.cut &&
          valueCheck.clarity === value.clarity &&
          valueCheck.typeSelect === value.typeSelect &&
          (valueCheck.updateCarat === value.updateCarat ||
            valueCheck.updatePice === value.updatePice)
      );

      if (index >= 0) {
        message.success("Product Added into cart");
      } else {
        // Add new item to cartValue
        const updatedCart = [...cartValue, value];
        setCartValue(updatedCart);
        setSessionStorageItem("cart", updatedCart);
        message.success("Product Added into cart");
      }
    } else {
      // Initialize cartValue with the new item
      const updatedCart = [value];
      setCartValue(updatedCart);
      setSessionStorageItem("cart", updatedCart);
      message.success("Product Added into cart");
    }
  };

  const contextbrnchdata = (data) => {
    setBranchDetail(data);
    // You can include any other logic or state updates you need here
  };
  ////branch id to c =======
  const updateBranchId = (id) => {
    setBranchId(id);
  };

  const makeAndEnquiry = async (
    name,
    number,
    email,
    message,
    title,
    sub_total,
    shipping_charges,
    total
  ) => {
    try {
      const data = {
        ...(sub_total && { dataProduct: cartValue }),
        name,
        number,
        email,
        message,
        sub_total,
        title,
        shipping_charges,
        total,
        action: "add",
      };

      const formData = new FormData();
      for (const key in data) {
        formData.append(key, data[key]);
      }
      const reps = await post("/enquiry.php", formData);

      if (reps) {
        return true;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const contextValue = {
    cartCount,
    handleCartList,
    handleAddCart,
    showCartList,
    cartValue,
    branchDetail,
    salesTextPrice,
    setBranchDetail,
    branchDetail,
    setBranchDetail,
    contextbrnchdata,
    guestDetails,
    setGuestDetails,
    updateGuestDetails,
    branchData,
    branchId,
    updateBranchId,
    // Removed updateBranchData because it's not defined,
    setCartValue,
    setCartCount,
    totalItemPrice,
    setShowCartList,
    totalPrice,
    setTipPrice,
    tipPrice,
    setTipPrice,
    selectedProduct,
    setSelectedProduct,
    setSelectedSize,
    setSelectedColor,
    setSelectedPrice,
    setSelectedImages,
    selectedSize,
    selectedColor,
    selectedPrice,
    selectedImages,
    amountDetails,
    setSelectedWeight,
    selectedWeight,
    setSelectedHight,
    selectedHight,
    setSelectedwidth,
    selectedwidth,
    makeAndEnquiry,
  };
  //brnchdetai

  useEffect(() => {
    const cartdata = JSON.parse(localStorage.getItem("cart"));
    if (cartdata && cartdata !== null) {
      setCartValue(cartdata);
      setCartCount(cartValue.length);
      if (cartValue && cartValue.length >= 0) {
        setCartValue((prevCartValue) => {
          let total = 0;
          prevCartValue.forEach((product) => {
            total += parseFloat(product.product_price);
          });
          const totalTax = (total * 10) / 100;
          const tax = parseFloat(totalTax.toFixed(2));
          const itemTotal = parseFloat(total.toFixed(2));
          const totalAdd = itemTotal + tax;
          const finalAmount = parseFloat(totalAdd.toFixed(2));

          // Use the callback function to ensure state is updated
          setAmountDetials((prevAmountDetails) => ({
            ...prevAmountDetails,
            texAmount: tax,
            subTotal: itemTotal,
            totalAmount: finalAmount,
          }));
          return prevCartValue;
        });
      }
    }
  }, []);

  return (
    <CartContext.Provider value={contextValue}>
      {contextHolder}
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
